import _ from 'lodash';
//constants
import { field, validationProps, validationTypes, fieldValidations } from './types';
import { EMAIL_REGEX, PHONE_REGEX } from 'constants/global.constants';
import { formConfig } from 'sections/pendingRequests/forms.types';
import { getRawAmountInputValue } from './helpers';

const getNumericValidationValue = (value: string) => getRawAmountInputValue(value);

export function loopValidateTypes(name: string, fieldValidations: fieldValidations = [], _value = '') {
	let isValid: validationProps = { name: name, valid: true, errorText: '' };
	const value = String(_value);
	const numericValue = getNumericValidationValue(value);
	fieldValidations.forEach((validation) => {
		if (_.has(validation, validationTypes.requierd)) {
			if (value === '' || _.isNil(value)) {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.required',
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.integer)) {
			if (value && value !== '') {
				const matchLetters = /^(0|[1-9]\d*)(\.\d{1,2})?$/i;
				isValid = _.isNil(numericValue.match(matchLetters))
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.integer',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.digitsOnly)) {
			if (value && value !== '') {
				const matchLetters = /^\d+$/i;
				isValid = _.isNil(value.match(matchLetters))
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.isNumber',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.maxNumber)) {
			if (numericValue && !_.isNaN(numericValue)) {
				isValid =
					Number(numericValue) > _.get(validation, validationTypes.maxNumber)
						? {
								...isValid,
								valid: false,
								errorText: '',
						  }
						: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.minNumber)) {
			if (numericValue && !_.isNaN(numericValue)) {
				isValid =
					Number(numericValue) < _.get(validation, validationTypes.minNumber)
						? {
								...isValid,
								valid: false,
								errorText: '',
						  }
						: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.exceedsBalance)) {
			if (numericValue && !_.isNaN(numericValue)) {
				const maxBalance = _.get(validation, validationTypes.exceedsBalance);

				isValid =
					Number(numericValue) > maxBalance
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.exceedsBalance',
						  }
						: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.latinLettersOnly)) {
			if (value && value !== '') {
				const matchLetters = /^([A-Za-z]|\s)+$/i;
				isValid = _.isNil(value.match(matchLetters))
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.alphabet',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.hebrewLettersOnly)) {
			if (value && value !== '') {
				const matchLetters = /^[\p{Script=Hebrew}\s]+$/u;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.hebrewletters',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.lettersOnly)) {
			if (value && value !== '') {
				const matchLetters = /^[\u0590-\u05FF\s|A-Za-z]*$/u;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.lettersOnly',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.address)) {
			if (value && value !== '') {
				const matchLetters = /^[a-zA-Z|\u0590-\u05FF\s|0-9]+[0-9]*$/u;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.address',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.addressHebrew)) {
			if (value && value !== '') {
				const matchLetters = /^[\u0590-\u05FF\s|0-9]+[0-9]*$/u;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.addressHebrew',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.addressEnglish)) {
			if (value && value !== '') {
				const matchLetters = /^([a-zA-Z]|\s|[0-9])+$/i;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.addressEnglish',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.latinLettersSpecialChars)) {
			if (value && value !== '') {
				const matchLetters = /^[a-zA-Z\s|0-9\\(\\)-\\"\\']*$/u;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.nameEnglish',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.latinLettersHyphensDigits)) {
			if (value && value !== '') {
				const matchLetters = /^[a-zA-Z\s|0-9-]*$/u;
				//const matchLetters = /^[\\d\\(\\)-\\"'']*$/i;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.latinLettersHyphensDigits',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.hebrewLettersSpecialChars)) {
			if (value && value !== '') {
				const matchLetters = /^[\u0590-\u05FF\s0-9()"'\\-]+$/;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.nameHebrew',
					  }
					: isValid;
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.email)) {
			if (!EMAIL_REGEX.test(value)) {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.email',
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.phone)) {
			if (!PHONE_REGEX.test(value)) {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.phone',
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.match)) {
			if (value === 'false') {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.not_match',
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.id)) {
			const intValue = parseInt(value);
			if (isNaN(intValue) || intValue < 1) {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.required',
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.balance)) {
			const balance = parseFloat(numericValue);
			if (isNaN(balance) || balance < 1) {
				isValid = { ...isValid, valid: false, errorText: 'validations.errors.minimum_1' };
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.checked)) {
			const checked = value === 'true';
			if (!checked) {
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.required',
				};
			}
		}

		if (isValid.valid && _.has(validation, validationTypes.noDecimalAllowed)) {
			if (value && value !== '') {
				const integerRegex = /^-?\d+$/;
				isValid = !integerRegex.test(numericValue)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.noDecimalsAllowed',
					  }
					: isValid;
			}
		}

		if (isValid.valid && _.has(validation, validationTypes.custom)) {
			/**
			 * custom = {
			 *  function : function that return boolean value
			 *  errorText : string or key of translate
			 * }
			 */
			const custom = _.get(validation, validationTypes.custom);
			if (_.isFunction(custom.function) && !custom.function(value)) {
				isValid = {
					...isValid,
					valid: false,
					errorText: custom.errorText,
				};
			}
		}
		if (isValid.valid && _.has(validation, validationTypes.hebrewLettersAndDigits)) {
			if (value && value !== '') {
				const matchLetters = /^[\u0590-\u05FF\s0-9()"'\\-]+$/;
				isValid = !matchLetters.test(value)
					? {
							...isValid,
							valid: false,
							errorText: 'validations.errors.nameHebrew',
					  }
					: isValid;
			}
		}
	});
	return isValid;
}

export function validateFields(
	fields: field[],
	data: { [key: string]: string },
	skipAmountValidation: boolean = false
) {
	let invalidsFields: { [key: string]: validationProps } = {};
	fields.forEach((field) => {
		if (skipAmountValidation && field.props?.name === 'amount') {
			return;
		}
		const value = _.has(data, field?.props?.name) ? _.get(data, field.props.name) : '';
		const isValid = loopValidateTypes(field.props.name, field.validation, value);
		if (!isValid.valid) {
			invalidsFields = { ...invalidsFields, [isValid.name]: isValid };
		}
	});
	return invalidsFields;
}

export function validateField(field: field, value: string) {
	const isValid = { name: field.props.name, valid: true, errorText: '' };
	if (!_.has(field, 'validation')) {
		return isValid;
	}
	return loopValidateTypes(field.props.name, field.validation, value);
}

export function setListOfInvalids(
	invalidFields: { [key: string]: validationProps },
	fieldsValidations: { [key: string]: validationTypes[] },
	name: string,
	value: string
) {
	if (_.has(fieldsValidations, name)) {
		const isValid = loopValidateTypes(name, _.get(fieldsValidations, name), value);
		if (!isValid.valid) {
			return { ...invalidFields, [isValid.name]: isValid };
		} else {
			if (_.has(invalidFields, isValid.name)) {
				return _.omit(invalidFields, isValid.name);
			}
		}
	}
	return invalidFields;
}
